import { Theme } from "@mui/material/styles";
import useMediaQueryMui from "@mui/material/useMediaQuery";

const useMediaQuery = useMediaQueryMui<Theme>;

export default useMediaQuery;
